import { IStringResources } from '../FontPicker/FontPicker.types.shared';

export const DefaultStringResources: IStringResources = {
    allFontsSectionLabel: 'Office Fonts',
    pinnedSectionLabel: 'Pinned Fonts',
    mruSectionLabel: 'Most Recently Used',
    infoCommandLabel: 'About This Font...',
    organizationSectionLabel: 'Organization Fonts',
    pinnedDescription: 'Pinned font',
    unPinnedDescription: 'Unpinned font',
    pinnedTooltip: 'Unpin font',
    unPinnedTooltip: 'Pin font',
    themeFontTooltip: 'Theme font',
    embeddedFontTooltip: 'Embedded font',
    premiumFontTooltip: 'Premium font',
    missingFontTooltip: 'Missing font',
    compatibleFontTooltip: 'Compatibility font',
    fontPinningTooltip: '(Shift+Enter to pin/unpin font)',
    fontMissingFontTooltip: 'Missing Font (Shift+Enter for more info)',
    fontOtherActionTooltip: '(Shift+Enter for more info)',
    pinnedFontAnnouncement: 'Pinned font {0}',
    unPinnedFontAnnouncement: 'Unpinned font {0}',
    numberOfSuggestionsAnnouncement: '{0} suggestions available for {1}',
    noSuggestionsAnnouncement: 'No suggestions available for {0}',
    numberOfSuggestionsInGroupAnnouncement: '{0} in {1}',
};
